import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingMarket: false,
  loadingCreateNewConfig: false,
  loadingDelete: false,
  loadingRaceConfig: false,
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_LIST_MARKET_CONFIG: (s, data) => (s.loadingMarket = data),
    LOAD_CREATE_NEW_MARKET_CONFIG: (s, data) =>
      (s.loadingCreateNewConfig = data),
    LOAD_DELETE_MARKET_CONFIG: (s, data) => (s.loadingDelete = data),
    LOAD_RACE_CONFIG: (s, data) => (s.loadingRaceConfig = data),
  },

  actions: {
    async getListMarketConfig({ commit }, params) {
      commit("LOAD_LIST_MARKET_CONFIG", true);
      try {
        const { sportId, leagueId, source } = params;
        const res = await this.$api.get(
          `/v1/portal/sports/${sportId}/leagues/${leagueId}/markets/config`,
          {
            params: { source },
          }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_MARKET_CONFIG", false);
      }
    },
    async createNewMarketConfig({ commit }, params) {
      commit("LOAD_CREATE_NEW_MARKET_CONFIG", true);
      try {
        const { sportId, leagueId, ...rest } = params;
        const res = await this.$api.post(
          `/v1/portal/sports/${sportId}/leagues/${leagueId}/markets/config`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_NEW_MARKET_CONFIG", false);
      }
    },
    async udpateMarketConfig({ commit }, params) {
      commit("LOAD_CREATE_NEW_MARKET_CONFIG", true);
      try {
        const { sportId, leagueId, ...rest } = params;
        const res = await this.$api.put(
          `/v1/portal/sports/${sportId}/leagues/${leagueId}/markets/config`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_NEW_MARKET_CONFIG", false);
      }
    },
    async deleteMarketConfig({ commit }, params) {
      commit("LOAD_DELETE_MARKET_CONFIG", true);
      try {
        const { sportId, leagueId, id } = params;
        const res = await this.$api.delete(
          `/v1/portal/sports/${sportId}/leagues/${leagueId}/markets/${id}/config`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_MARKET_CONFIG", false);
      }
    },
    async getListLeagueConfig({ commit }, params) {
      commit("LOAD_LIST_MARKET_CONFIG", true);
      try {
        const { sportId } = params;
        const res = await this.$api.get(
          `/v1/portal/sport-config/${sportId}/leagues`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_MARKET_CONFIG", false);
      }
    },
    async deleteLeagueConfig({ commit }, params) {
      commit("LOAD_DELETE_MARKET_CONFIG", true);
      try {
        const { sportId, id } = params;
        const res = await this.$api.delete(
          `/v1/portal/sport-config/${sportId}/league/${id}`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_MARKET_CONFIG", false);
      }
    },
    async createNewLeagueConfig({ commit }, params) {
      commit("LOAD_CREATE_NEW_MARKET_CONFIG", true);
      try {
        const { sportId, ...rest } = params;
        const res = await this.$api.post(
          `/v1/portal/sport-config/${sportId}/league`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_NEW_MARKET_CONFIG", false);
      }
    },
    async getDataRaceConfig({ commit }) {
      commit("LOAD_RACE_CONFIG", true);
      try {
        const res = await this.$api.get("/v1/settings/detail?key=race-config");
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_RACE_CONFIG", false);
      }
    },
    async updateDataRaceConfig({ commit }, payload) {
      commit("LOAD_RACE_CONFIG", true);
      try {
        const res = await this.$api.post("/v1/portal/settings/update", payload);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_RACE_CONFIG", false);
      }
    },
  },
};
